<div class="row">
  <div class="col-lg-6 offset-lg-3 col-md-6 offset-md-3">
    <h3>{{'i18n.core.navigation.editProfile' | translate}}</h3>
    <div class="e-card">
      <div class="e-card-content">
        <app-user-edit-form [userEditForm]="userEditForm"></app-user-edit-form>
        <div class="d-flex justify-content-end mt-3">
          <button type="submit"
                  class="btn btn-primary"
                  (click)="save()"
                  [disabled]="!userEditForm.valid">
            {{ 'i18n.shared.save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
